import React, { useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import LabelInput from '../Input/labelInput/labelInput';
import localization from 'assets/localization/localization';
import { countryCode } from 'constants/countryCode/countryCode';
import Config from 'services/config/config';
import axios from "../../../services/interceptor/Interceptor";
import {toast} from "react-toastify";
import { Button } from 'react-bootstrap';


const SearchLocation = ({
  handleCurrentLocationBlur,
  handleCurrentLocationChange,
  value,
  isError,
  setSelectedLocation=null
}) => {
  let autoComplete;

  const loadScript = (url, callback) => {
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'search_current_location';
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (
          script.readyState === 'loaded' ||
          script.readyState === 'complete'
        ) {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = () => callback();
    }
    let elm = document.querySelectorAll('head>script');
    for (let i = 0; i < elm.length; i++) {
      elm[i].remove();
    }
    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
  };

  function handleScriptLoad(
    updateQuery,
    setLatLng,
    setIsblank,
    autoCompleteRef
  ) {
    setIsblank(false);
      autoComplete = new window.google.maps.places.Autocomplete(
        autoCompleteRef.current,
        {
          types: [],
          componentRestrictions: { country: countryCode.in },
        }
      );
      autoComplete.setFields([
        'address_component',
        'geometry',
        'formatted_address',
      ]);
  
      autoComplete.addListener('place_changed', () => {
        handlePlaceSelect(updateQuery, setLatLng, setIsblank);
      });
  }

  async function handlePlaceSelect(updateQuery, setLatLng, setIsblank) {
    setTimeout(() => {
      setIsblank(true);
    }, 100);
    const addressObject = autoComplete.getPlace();
    const query = addressObject.formatted_address;
    updateQuery(query);
    setLatLng({
      lat: Number(addressObject.geometry.location.lat()).toFixed(3),
      lng: Number(addressObject.geometry.location.lng()).toFixed(3),
    });
  }

  const [query, setQuery] = useState(value);
  const [latlng, setLatLng] = useState('');
  const [isblank, setIsblank] = useState(false);
  const autoCompleteRef = useRef(null);

  useEffect(() => {
    setQuery(value);
  }, [value]);

  useEffect(() => {
    if (latlng !== null && latlng !== undefined && isblank === true) {
      if(setSelectedLocation!=null){
        setSelectedLocation(query)
      }
      handleCurrentLocationBlur(latlng);
    } else {
      handleCurrentLocationBlur(null);
    }
  }, [latlng, isblank]);

  // useEffect(() => {
  //   // console.log(query.length);
  //   if (query && query.length > 2) {
  //     saveData(query);
  //     loadScript(Config.googleAPI.placeSearch, () =>
  //     handleScriptLoad(setQuery, setLatLng, setIsblank, autoCompleteRef)
  //   );
  //     handleCurrentLocationChange(query);
  //   }
  // }, [query]);

  async function saveData(query) {
  try {
      let url;
      url = Config.profileUrl.saveLocation;
      const payload = {
        query_search: query,
        module: 'project_onboarding'
      };
    await axios.post(url, payload);
    } catch (error) {
    }
  };

  const applySearchKey = () => {
    saveData(query);
      loadScript(Config.googleAPI.placeSearch, () =>
        handleScriptLoad(setQuery, setLatLng, setIsblank, autoCompleteRef)
        )
      handleCurrentLocationChange(query);
      setTimeout(() => {
       document.getElementById('searchKeyElement').focus();
      //  document.getElementById('search_current_location').setAttribute('src','');
      }, 50);
      // console.log(abc);
  }

  useEffect(() => {
    // console.log(query);
    // if (query && query.length > 2) {
    // loadScript(Config.googleAPI.placeSearch, () =>
    //   handleScriptLoad(setQuery, setLatLng, setIsblank, autoCompleteRef)
    // );
    // }
  }, []);

  const handleBlur = () => {
    setIsblank(false);
    handleCurrentLocationBlur(null);
  };


  return (
    <div className="search-location-input">
      <div className='row'>
        <div className='col-10'>
          <LabelInput
          label={localization.current_location}
          isError={isError}
          type="text"
          id="searchKeyElement"
          handleChange={(val) => {
            setQuery(val.target.value);
          }}
          className={`${query !== '' ? '' : 'empty'}`}
          onBlur={handleBlur}
          inputValue={query}
          ref={autoCompleteRef}
          required
          isStarRequired={true}
          errorMsg={localization.isRequired}
        />
        </div>
        <div className='col-2'>
        <button type="button" className="btn btn-outline-primary btn-primary colorBox borderColorBox" onClick={applySearchKey}>🔍 </button>
        </div>
      </div>
      
      

    </div>
  );
};

SearchLocation.propTypes = {
  handleCurrentLocationBlur: PropTypes.func,
  handleCurrentLocationChange: PropTypes.func,
  value: PropTypes.any,
  isError: PropTypes.bool,
};

export default SearchLocation;
